// Publishable by design: the database only allows the `submit_signup` function call with this key.
export const SUPABASE_URL = 'https://lvhgwkuvgrjgjuxlgunl.supabase.co';
export const SUPABASE_KEY = 'sb_publishable_kFr9uamjl8_FgI9-kEqbXw_av0mqQ0L';
